<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '分组'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="85px" :rules="rules">
      <el-form-item label="分组名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入分组名称"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="Comment">
        <el-input v-model.trim="item.Comment"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入说明">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !item.Name">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '分组名称不能为空', trigger: 'blur' },
          { max: 100, message: '分组名称不能超过100个字', trigger: 'blur' },
        ],
        Comment: [
          { max: 64000, message: '内容过多', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `ipcdgroup/${itemData.ID}` : 'ipcdgroup',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
